import { render, staticRenderFns } from "./StclL_Search.vue?vue&type=template&id=8840bf76"
import script from "./StclL_Search.vue?vue&type=script&lang=js"
export * from "./StclL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports